<template>
    <div>
        <a-alert message="请输入与帐号绑定的手机号进行短信校验" type="info" show-icon />
        <a-form :model="passForm" :rules="rules" class="phone" style="margin-top: 32px">
            <a-form-item v-bind="validateInfos.mob">
              <a-input v-model:value="passForm.mob" size="large" :maxLength="11" :minLength="11"
                       onkeyup="this.value=this.value.replace(/\D/g,'')" placeholder="手机号">
                <template #prefix>
                    <MobileOutlined style="color: rgba(0, 0, 0, 0.25)" />
                </template>
              </a-input>
            </a-form-item>
            <a-form-item v-bind="validateInfos.verkey">
                <a-input v-model:value="passForm.verkey" size="large" style="width: 70%; float: left" placeholder="验证码">
                    <template #prefix>
                        <UserOutlined type="user" style="color: rgba(0, 0, 0, 0.25)" />
                    </template>
                </a-input>
                <a-button v-if="codeShow" type="primary" class="code"
                          @click="handlerPassForm(passForm)">
                    {{ passText }}
                </a-button>
                <a-button v-else disabled class="code">
                    {{ newtimes }}秒后重试
                </a-button>
            </a-form-item>
            <div class="remenber"></div>
            <a-form-item>
                <a-button type="primary"
                          @click="handlerNext(passForm)"
                          style="width: 100%; height: 40px">下一步</a-button>
            </a-form-item>
         </a-form>
    </div>
</template>

<script>
import { $post, $get } from "@/utils/request";
import { phoneTips, verkeyCode } from "@/views/components/api/api";
import { message } from "ant-design-vue";
import Termsindex from "@/views/login/terms.vue";
import { UserOutlined, LockOutlined, MobileOutlined, UpCircleOutlined, LeftCircleOutlined } from "@ant-design/icons-vue";
import { reactive, toRaw } from 'vue';
import { Form } from 'ant-design-vue';
const useForm = Form.useForm;
export default {
    components: { Termsindex, UserOutlined, LockOutlined, MobileOutlined, UpCircleOutlined, LeftCircleOutlined },
    props: {
        terms: '',
        is_user: '',
    },
    emits: [
        "handlerForget",
    ],
    data(){
        const passForm = reactive({
            mob: '',
            verkey: "",
            typ: "2",
        });
        const rules = reactive({
            mob: [
                { required: true, validator: phoneTips },
            ],
            verkey: [
                { required: true, validator: verkeyCode },
            ],
        });
        const { validate, validateInfos } = useForm(passForm, rules);
        return {
            passForm,
            validate,
            validateInfos,
            rules,
            loading: false,
            button_login: "登录",
            codeShow: true,
            times: 60,
            newtimes: 60,
            passText: "获取验证码",
        };
    },
    methods:{
        // 忘记密码获取验证码
        handlerPassForm(s) {
            if (s.mob  != '' && s.mob.length == '11') {
                $post({
                    url: "auth/getVerCode/",
                    params: s,
                }).then((res) => {
                    message.success("发送成功");
                    this.codeShow = false;
                    setInterval(() => {
                        if (this.newtimes > 0 && this.newtimes <= 60) {
                            this.newtimes--;
                        } else {
                            this.codeShow = true;
                            this.passText = "重新发送";
                            this.newtimes = 60;
                        }
                    }, 1000);
                }).catch((err) => {
                    message.error(err);
                });
            } else if (s.mob.length < 11) {
                message.error('请输入正确的手机号')
            } else if (s.mob == '') {
                message.error('请先输入手机号')
            }
        },
        // 下一步
        handlerNext(form) {
            this.validate().then(() => {
                this.$emit('handlerForget',form)
            }).catch(err => {
                this.loading = false;
            });
        },
    },
    mounted() {
        localStorage.setItem("query", JSON.stringify({}));
    },
}
</script>

<style lang="less">
.remenber {
    width: 368px;
    height: 50px;
    padding: 24px 0;
    font-size: 14px;
}
</style>